module.exports = __webpack_public_path__ + "static/white-logo-1e76edd35e3c3e41b6025ce9c9c82dbe.svg";